import React, { Component } from "react";
import Header from "./common/Header";
import Sidebar from "./common/Sidebar";

import { Link } from "react-router-dom";

import NumberFormat from "react-number-format";

import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";

export class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage["appState"]
        ? JSON.parse(localStorage["appState"]).user.token
        : "",
      user: [],
      user_transactions: []
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser(){
    axios
            .get(`${axios.defaults.baseURL}/user/${JSON.parse(localStorage["appState"]).user.id}`,
            {
              headers: {
                'Authorization': `Bearer ${this.state.token}`
              }
            }
            )
            .then(response => {
              //console.log(response);
              return response;
            })
            .then(json => {
              if (json.data.success) {
                this.setState({ user: json.data.user[0], 
                    user_transactions: json.data.user_transactions });
              // } else alert("Cannot Fetch Data!");
              } else swal("Oops!", "Cannot Fetch Data!", "error");;
            })
            .catch(error => {
              console.error(`An Error Occured! ${error}`);
            });
            // alert(id)
  }

  render() {
    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div className="page-title">
                    <div className="row text-primary py-2 pt-4">
                      <div className="col-10">
                        <div
                          className="user-welcome"
                          style={{ overflow: "hidden" }}
                        >
                          <div className="wrapper d-flex mt-2">
                            <h4 className="d-inline-block">
                              My Transactions
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="text-right col-2"></div>
                    </div>
                  </div>
                  {this.state.isLoading ? (
                    <div
                      data-v-22924209=""
                      class="dash-card-plan bg-white"
                    >
                      <div className="dash-card-main bg-cover blink_me text-center">
                        <br />
                        Loading...
                        <br />
                        <br />
                      </div>
                    </div>
                  ) : (
                    <>
                      {this.state.user_transactions != "" ? (
                        <div className="align-items-stretch">
                          <table class="table">

                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">S/N</th>
                        <th scope="col">Transaction Type</th>
                        <th scope="col">Amount (₦)</th>
                        <th scope="col">Date</th>
                      </tr>
                    </thead>
                            <tbody>
                              {this.state.user_transactions.map((transaction, index) => (
                                <tr>
                                  <td>{index+1}</td>
                                  <td>{transaction.type}</td>
                                  <td>
                                  <NumberFormat value={transaction.amount} displayType={'text'} thousandSeparator={true} prefix={''} /></td>
                                  <td>{transaction.date}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          data-v-22924209=""
                          class="empty-placeholder dash-card bg-white"
                        >
                          You have no transactions yet.
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Transactions;
